var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFloorIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.61 7.90909H21.75V21H11.61M11.61 7.90909V3H2.25V19.7727M11.61 7.90909V19.7727M11.61 21H2.25V19.7727M11.61 21V19.7727M6.93 18.5455H3.03V14.4545H6.93M6.93 18.5455V14.4545M6.93 18.5455H10.83V14.4545H6.93M11.61 19.7727H2.25M6.93 13.6364H3.03V9.54545H6.93M6.93 13.6364V9.54545M6.93 13.6364H10.83V9.54545H6.93M6.93 8.72727H3.03V4.63636H6.93M6.93 8.72727V4.63636M6.93 8.72727H10.83V4.63636H6.93M12.39 11.1818H13.17V12H12.39V11.1818ZM17.07 11.1818H17.85V12H17.07V11.1818ZM12.39 16.0909H13.17V16.9091H12.39V16.0909ZM17.07 16.0909H17.85V16.9091H17.07V16.0909Z",
    stroke: "#065BA9",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFloorIcon);
export default __webpack_public_path__ + "static/media/FloorIcon.027c6235dc7ac366b6d54b87da6e3538.svg";
export { ForwardRef as ReactComponent };